<ng-container *ngIf="changepasswordLoader">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-container>
<mat-card class="MainThemeBody" [class.leftmenusmall]="isActive">
    <div class="topLogo"><img src="https://all-frontend-assets.s3.amazonaws.com/broko-design/broko_v1_logo.png" alt="#">
    </div>
    <mat-card class="dashboardBody">
        <aside class="leftmenuBody">
            <app-leftmenu></app-leftmenu>
        </aside>

        <section class="dashboarSection">
            <section class="dashboarMainWrapper">
                <header class="MainHeader">
                    <div class="arrow_leftBTN" (click)="toggleActive()"><mat-icon>keyboard_arrow_left</mat-icon></div>
                    <app-header></app-header>
                </header>

                <h1 class="mainTitle"> Change Password</h1>


                
                <!-- ============================================================================================================================================ -->
                <!-- ============================================================================================================================================ -->
                <!-- ============================================================================================================================================ -->
                <!-- ============================================================================================================================================ -->
                <!--====================== common block start======================-->
                <div class="bodyWrapper">

                    <!--====================== dynamic block start======================-->

                    <div class="addEditForm changePassWrapper">
                         
                        <lib-showform class=" addEditFormblock" *ngIf="formdatachngpass != null" [formdata]="formdatachngpass" [formfieldrefresh]="formfieldrefreshpass" [formfieldrefreshdata]="formfieldrefreshdatapass" (onFormFieldChange)="listenFormFieldChange($event)">
                        </lib-showform>
            
                    </div>

          
                    <!--====================== dynamic block end ======================-->
                </div>

                <!--====================== common block end======================-->
                <!-- ============================================================================================================================================ -->
                <!-- ============================================================================================================================================ -->
                <!-- ============================================================================================================================================ -->
                <!-- ============================================================================================================================================ -->


            </section>

            <footer class="MainFooter"><app-footer></app-footer></footer>

        </section>


    </mat-card>

</mat-card>